var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)
            if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
    return t;
};
import nodeCopy from './copy';
export function assign(t, copy, extension) {
    const _a = extension, {type} = _a, rest = __rest(_a, ['type']);
    const copied = (copy || nodeCopy)(Object.assign({}, rest));
    Object.assign(t, copied);
    return t;
}
export default assign;    //# sourceMappingURL=assign.js.map
